export const headerToggle = () => {
	const mainContainer = document.querySelector('.main-container');
	const header = document.querySelector('.header');
	// const menu = document.querySelector('.navigation__menu');
	const headerActive = 'navigation__menu--active';
	const headerWhite = 'header--white';
	const scrollUp = 'header--show';
	const scrollDown = 'header--hide';
	let lastScroll = 0;

	window.addEventListener("scroll", () => {
		const currentScroll = window.pageYOffset;
		if (currentScroll <= 0) {
			header.classList.remove(headerWhite);
			return;
		};

		if (currentScroll <= 110) {
			header.classList.remove(scrollUp);
			return;
		};

		if (!header.classList.contains(headerActive)) {
			if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
				// down
				header.classList.remove(scrollUp);
				header.classList.add(scrollDown);
			} else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) {
				// up
				header.classList.remove(scrollDown);
				header.classList.add(scrollUp, headerWhite);
			}
		} else {
			header.classList.add(headerWhite);
		};
		
		lastScroll = currentScroll;
	});
};
